<p-multiSelect (onChange)="onChangeMultiSelect($event)" [(ngModel)]="selectedOptions"  [ngStyle]="getChildStyle()"
               [options]="options" [scrollHeight]="'400px'" [showToggleAll]="true"
               [filter]="true"
               [filterMatchMode]="'contains'"
               (onFilter)="onCustomFilter($event)"
               filterBy="searchText"
               appendTo="body">
  <ng-template pTemplate="selectedItems">
    <span>{{ getSelectedItemsLabel() }}</span>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <span>{{ option.label }}</span>
    <div (click)="onClickChildOptionContainer($event)" *ngFor="let childOption of option.value.childOptions" class="child-option-checkbox">
      <p-checkbox (click)="onClickChildOptionCheckbox($event)" (onChange)="onChangeChildOptionCheckbox(option)" [(ngModel)]="option.value.selectedChildOptions"
                  [value]="childOption.value" label="{{childOption.label}}"
                  name="{{option.label}}"></p-checkbox>
    </div>
  </ng-template>
</p-multiSelect>
